import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private apiClient: ApiClientService) {
  }

  changePassword(password: string): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      this.apiClient.post('/account/change-password', {}, {password}, {ignoreBadRequest: true}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
